module.exports = __webpack_public_path__ + "static/media/limestone.3822b090.png";